import { createAction, props } from '@ngrx/store';
import { ClosureDetail, ClosureQueryResult, FlatterFilesResponse } from '../../models';
import { LookupValue } from '../../models/lookup.model';

const loadClosureQueryResult = createAction('[Closures] Load Closures');
const loadClosureQueryResultSuccess = createAction('[Closures] Load Closures Success', props<{ res: ClosureQueryResult[] }>());
const loadClosureQueryResultFailure = createAction('[Closures] Load Closures Failure', props<{ error: any }>());

const loadClosureLookups = createAction('[Closures] load lookups', props<{ force?: boolean }>());
const loadClosureLookupsSuccess = createAction('[Closures] load lookups success', props<{
  diameters: LookupValue[],
  designCodes: LookupValue[],
  designFactors: LookupValue[],
  wallThicknesses: LookupValue[],
  hingeOrientations: LookupValue[],
  pressureRatings: LookupValue[],
  clampRings: LookupValue[],
  flangeClasses: LookupValue[],
  classRatings: LookupValue[]
}>());
const loadClosureLookupsFail = createAction('[Closures] load lookups fail', props<{ error: any }>());

const loadClosureDetail = createAction('[Closures] load Detail');
const loadClosureDetailSuccess = createAction('[Closures] load Detail success', props<{ detail: ClosureDetail }>());
const loadClosureDetailFail = createAction('[Closures] load Detail fail', props<{ error: any }>());
const activateClosureByPartNumber = createAction('[Closures] load Closure by part number', props<{ partNumber: string }>());

const activateClosure = createAction('[Closures] change active closure', props<{ id: number }>());
const clearClosure = createAction('[CLOSURES] clear selected');

const loadClosureDrawing = createAction('[Closures] Get Drawing', props<{ detail: ClosureDetail }>());
const loadClosureDrawingSuccess = createAction('[Closures] Get Drawing Success');
const loadClosureDrawingFail = createAction('[Closures] Get Drawing fail', props<{ error: any }>());

const changeDiameter = createAction('[Closures] change diameter', props<{ diameter: number }>());
const changeClampRing = createAction('[CLosures] change clamp ring', props<{ clampRingId?: number }>())
const changeFlanged = createAction('[Closures] change flanged', props<{ flanged: boolean }>());
const changeDesignPressure = createAction('[Closures] change designPressure', props<{ designPressure: number }>());
const changeDesignPressureUnit = createAction('[Closures] change designPressure unit', props<{ designPressureUnit: number }>());
const changeDesignTempMin = createAction('[Closures] change DesignTempMin', props<{ designTempMin: number }>());
const changeDesignTempMax = createAction('[Closures] change DesignTempMax', props<{ designTempMax: number }>());
const changeHingeOrientation = createAction('[Closures] change HingeOrientation', props<{ hingeOrientation: number }>());
const changeDesignFactorId = createAction('[Closures] change DesignFactorId', props<{ designFactorId: number }>());
const changeDesignCodeId = createAction('[Closures] change DesignCodeId', props<{ designCodeId: number }>());
const changeFlangeClass = createAction('[Closures] change flangeClassId', props<{ flangeClassId: number }>());
const changeClassRating = createAction('[Closures] change classRatingId', props<{ classRatingId: number }>());

export const loadActiveClosureDrawingDictionary = createAction('[CLOSURES] loadActiveClosureDrawingDictionary');
export const loadActiveClosureDrawingDictionarySuccess = createAction('[Closures] loadActiveClosureDrawingDictionary Success', props<{ dictionary: { [key: string]: FlatterFilesResponse } }>());
export const loadActiveClosureDrawingDictionaryFail = createAction('[Closures] loadActiveClosureDrawingDictionary Fail', props<{ error: any }>());


export const loadDrawingFromFlatterFiles = createAction('[CLOSURES] Get flatter files dwg', props<{ filename: string }>());
export const loadDrawingFromFlatterFilesSuccess = createAction('[CLOSURES] Get flatter files Success');
export const loadDrawingFromFlatterFilesFail = createAction('[CLOSURES] Get flatter files fail', props<{ error: any }>());


export {
  loadClosureQueryResult,
  loadClosureQueryResultSuccess,
  loadClosureQueryResultFailure,
  loadClosureLookups,
  loadClosureLookupsSuccess,
  loadClosureLookupsFail,
  loadClosureDetail,
  loadClosureDetailSuccess,
  loadClosureDetailFail,
  activateClosure,
  activateClosureByPartNumber,
  clearClosure,
  loadClosureDrawing,
  loadClosureDrawingSuccess,
  loadClosureDrawingFail,
  changeDiameter,
  changeClampRing,
  changeFlanged,
  changeDesignPressure,
  changeDesignPressureUnit,
  changeDesignTempMin,
  changeDesignTempMax,
  changeHingeOrientation,
  changeDesignFactorId,
  changeDesignCodeId,
  changeFlangeClass,
  changeClassRating
}
